import moment from "moment";

export const getCurrentDate = async () => {
    return moment.utc(new Date()).local().add(0, 'hours').format('YYYY-MM-DD');
}

export const getCurrentDateFormat =  () => {
    return moment.utc(new Date()).local().add(0, 'hours').format('YYYY-MM-DD');
}
